import { AuditLogEntry } from 'apis/auditLogs';

export const automatedActivityTypes: AuditLogEntry['activity_type'][] = [
  'CONVERSATION_CREATED_BY_CUSTOMER',
  'CONVERSATION_CREATED_BY_AGENT',
  'CONVERSATION_OFFERED',
  'CONVERSATION_CLOSED',
  'CONVERSATION_PENDING',
  'CONVERSATION_RESERVED',
];
